import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    sidebarOpen: false,
  }),
  actions: {
    openSidebar()  { this.sidebarOpen = true; },
    closeSidebar() { this.sidebarOpen = false; },
    toggleSidebar(){ this.sidebarOpen = !this.sidebarOpen; },
  },
});